import React from 'react';
import { ToggleSwitch } from '../../../../components/ToggleSwitch';
import type { ImapConfig } from './ImapSource';

interface Props {
  config: ImapConfig;
  onChange: (config: ImapConfig) => void;
  disabled: boolean;
}

// IMAP step 3: provider-specific credentials. Standard providers need email + password;
// "custom" additionally needs server host, port, and an SSL toggle.
export function ImapCredentialsForm({ config, onChange, disabled }: Props) {
  const set = (updates: Partial<ImapConfig>) => onChange({ ...config, ...updates });
  const isCustom = config.provider === 'custom';

  return (
    <div>
      {isCustom ? (
        <h4>Add a Mail Account</h4>
      ) : config.provider ? (
        <img src={`images/email/${config.provider}.png`} alt={config.provider} style={{ maxHeight: 48, marginBottom: 12 }} />
      ) : null}

      <div className="row" style={{ marginBottom: 10 }}>
        <div className="col-md-6">
          <div className="input-group">
            <span className="input-group-addon"><i className="fas fa-user" aria-hidden="true" /></span>
            <input
              type="email"
              placeholder="Email Address"
              className="form-control"
              value={config.username}
              onChange={e => set({ username: e.target.value })}
              maxLength={255}
              disabled={disabled}
            />
          </div>
        </div>
      </div>

      <div className="row" style={{ marginBottom: 10 }}>
        <div className="col-md-6">
          <div className="input-group">
            <span className="input-group-addon"><i className="fas fa-key" aria-hidden="true" /></span>
            <input
              type="password"
              autoComplete="new-password"
              placeholder="Password"
              className="form-control"
              value={config.password}
              onChange={e => set({ password: e.target.value })}
              maxLength={255}
              disabled={disabled}
            />
          </div>
        </div>
      </div>

      {isCustom && (
        <div className="row">
          <div className="col-md-6">
            <div className="input-group">
              <span className="input-group-addon"><i className="fas fa-server" aria-hidden="true" /></span>
              <input
                type="text"
                placeholder="IMAP Server Address"
                className="form-control"
                value={config.host}
                onChange={e => set({ host: e.target.value })}
                maxLength={255}
                disabled={disabled}
              />
            </div>
          </div>
          <div className="col-md-2">
            <input
              type="number"
              className="form-control"
              value={config.port}
              onChange={e => set({ port: parseInt(e.target.value, 10) || (config.ssl ? 993 : 143) })}
              disabled={disabled}
            />
          </div>
          <div className="col-md-3" style={{ paddingTop: 3 }}>
            <ToggleSwitch
              checked={config.ssl}
              onChange={ssl => set({ ssl, port: ssl ? 993 : 143 })}
              disabled={disabled}
              onLabel="SSL ON"
              offLabel="SSL OFF"
            />
          </div>
        </div>
      )}
    </div>
  );
}
